module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_13_3.acca0c50.jpeg";